import React, { useRef, useState, useEffect, useCallback } from 'react';

import { CollapsibleContainer, CollapsibleChildren } from './styles';

interface ICollapsibleBodyProps {
  children: React.ReactNode;
  isOpen: boolean;
  customBodyStyle?: React.CSSProperties;
  checkHeightAgain?: number;
  nested?: boolean;
  showOverflow?: boolean;
}

const CollapsibleBody: React.FC<ICollapsibleBodyProps> = ({
  children,
  isOpen,
  customBodyStyle,
  checkHeightAgain,
  nested,
  showOverflow = false,
}) => {
  const [maxHeight, setMaxHeight] = useState<number>(0);
  const content = useRef<HTMLDivElement>(null);

  const handleResize = () =>
    setMaxHeight(isOpen && content.current ? content.current.scrollHeight : 0);

  const handleResizeCallback = useCallback(handleResize, [isOpen]);
  useEffect(() => {
    handleResize();
  }, [children]);
  useEffect(() => {
    window.addEventListener('resize', handleResizeCallback);
    return () => {
      window.removeEventListener('resize', handleResizeCallback);
    };
  }, [handleResizeCallback]);

  useEffect(() => {
    setMaxHeight(isOpen ? content.current!.scrollHeight : 0);
  }, [isOpen, children, checkHeightAgain]);

  return (
    <CollapsibleContainer
      ref={content}
      maxHeight={nested && maxHeight ? 'unset' : maxHeight}
      open={isOpen}
      showOverflow={showOverflow}
    >
      <CollapsibleChildren style={customBodyStyle && customBodyStyle}>
        {children}
      </CollapsibleChildren>
    </CollapsibleContainer>
  );
};

export default CollapsibleBody;
